import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Chumbox News - Your Source for Trending News and Cultural Commentary" 
          className="hero-image" 
        />
        <p className="eyebrow">Chumbox News</p>
        <h1>Your Hub for Trending News and Cultural Insights</h1>
        <p className="lede">
          Stay ahead of the curve with Chumbox News, where you can find the latest headlines and in-depth cultural commentary that matters to you.
        </p>
        <div className="cta-row">
          <a href="/latest" target="_self">
            Explore the Latest News
          </a>
          <a href="/commentary" target="_self" className="secondary">
            Read Cultural Commentary
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Stay Updated</h2>
          <p>
            Access timely updates on the most significant stories, from breaking news to cultural events that shape our society.
          </p>
        </article>
        <article>
          <h2>Diverse Voices</h2>
          <p>
            Engage with insightful analysis and commentary on the cultural trends influencing our lives today.
          </p>
        </article>
        <article>
          <h2>Join the Conversation</h2>
          <p>
            Connect with a community of news and culture enthusiasts. Share your views and engage in meaningful discussions.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;